import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';

import type {
    OnboardingModuleFragment,
    UserEmailCalendarStatusesFragment,
    OnboardingQuotesFragment,
    UserVideoIntegrationsFragment,
} from 'nutshell-graphql-types';

import {ExplorePageSectionHeader} from '../explore-page-section-header';
import type {ExplorePageVariant} from '../types';

import {OnboardingModule} from './onboarding-module';

type Props = {
    title: string;
    modules: OnboardingModuleFragment[] | null | undefined;
    isLoading: boolean;
    hasFullSchedulerAccess: boolean;
    userEmailCalendarStatuses: UserEmailCalendarStatusesFragment | null | undefined;
    onboardingQuotes: OnboardingQuotesFragment | null | undefined;
    userVideoIntegrations: UserVideoIntegrationsFragment | null | undefined;
    hasClickToCallConnected?: boolean;
    hasPhoneIntegrationConnected?: boolean;
    variant: ExplorePageVariant;
    onEmailCalendarAuthSuccess?: (provider: 'google' | 'microsoft') => void;
    additionalOnboarding?: React.ReactElement | null | undefined;
};

export function OnboardingModulesList(props: Props) {
    return (
        <Stack spacing={16}>
            <ExplorePageSectionHeader title={props.title} />
            {props.isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {props.additionalOnboarding ? <div>{props.additionalOnboarding}</div> : null}
                    {props.modules &&
                        props.modules.map((module) => (
                            <OnboardingModule
                                key={module.type}
                                module={module}
                                hasFullSchedulerAccess={props.hasFullSchedulerAccess}
                                isAdmin={NutClientConfig.loggedInUserIsAdmin}
                                userEmailCalendarStatuses={props.userEmailCalendarStatuses}
                                onboardingQuotes={props.onboardingQuotes}
                                userVideoIntegrations={props.userVideoIntegrations}
                                hasClickToCallConnected={props.hasClickToCallConnected}
                                hasPhoneIntegrationConnected={props.hasPhoneIntegrationConnected}
                                variant={props.variant}
                                onEmailCalendarAuthSuccess={props.onEmailCalendarAuthSuccess}
                            />
                        ))}
                </>
            )}
        </Stack>
    );
}
